import { useState } from "react";

import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { DirectoryPopupFooter } from "./Common/DirectoryPopupFooter";

interface IFlagAsInvalidWarningPopupProps {
    entityId: string;
    closePopup: () => void;
    flagAsInvalid: (id: string, reason: string) => Promise<void>;
}

export function FlagAsInvalidWarningPopup(props: IFlagAsInvalidWarningPopupProps): JSX.Element {
    const { getText } = useTranslation();
    const [reason, setReason] = useState<string>();

    return (
        <Modal
            title={getText("WarningLabel")}
            onClose={() => props.closePopup()}
            showOverlay
            fixedOverlayPosition
            centerContent
            footer={(
                <DirectoryPopupFooter
                    disableInvalidateButton={IsNullOrWhiteSpace(reason)}
                    onCancel={() => props.closePopup()}
                    onInvalidate={() => props.flagAsInvalid(props.entityId, reason)}
                />
            )}
            width={550}
        >
            <p>
                <span className="bold">{getText("DirectoryDeleteWarningLabel")} </span>
                {getText("DirectoryDeleteConfirmationLabel")}
            </p>
            <p className="margin-md-top margin-md-bottom">{getText("DirectoryDeleteSuggestionLabel")}</p>
            <TextboxControl
                value={reason}
                onChange={value => setReason(value)}
                valid={!IsNullOrWhiteSpace(reason)}
                maxLength={250}
            />
        </Modal>
    );
}
